import React, { useEffect, useState, useRef } from 'react';

import { FaAngleDown } from 'react-icons/fa'

import KidsIcon from '../../assets/icons/boy_s.png';

import Skeleton from '../Skeleton';

import { useListChildren } from "../../hooks/ParentContext";
import { useAuth } from "../../hooks/AuthContext";

import { Header, Popover } from './styles';

const ChildHeader = ({ }) => {
  const buttonRef = useRef(null);
  const { user } = useAuth();
  const { allChildren, selectedOne, setSelectedOne, loading } = useListChildren();
  const [loadingHeader, setLoadingHeader] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMoreThanOne, setIsMoreThanOne] = useState(false);

  const childLocal = localStorage.getItem("@Ocariot:child");

  useEffect(() => {
    if (user.type == 2) {
      if(selectedOne.nickname === undefined) setSelectedOne(JSON.parse(childLocal))
      setTimeout(() => {
        setLoadingHeader(false);
      }, 500);
    }
    if (allChildren.length !== 0) {
      setLoadingHeader(false);

      if (allChildren.length > 1) setIsMoreThanOne(true)
    };
  }, [allChildren, loadingHeader, selectedOne])

  useEffect(() => {
    const handleDropdown = event => {
      if (buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        isDropdownOpen
      ) setIsDropdownOpen(true);
    }

    document.addEventListener('mousedown', handleDropdown);

    return () => document.removeEventListener('mousedown', handleDropdown);
  }, [buttonRef, isDropdownOpen]);
  return (
    <Header ref={buttonRef}>
      {isMoreThanOne ? (
        <>
          {loadingHeader ? (
            <div className="loading">
              <Skeleton circle={true} height={48} width={48} />
              <Skeleton height={20} width={150} />
            </div>
          ) : (
            <button ref={buttonRef} className={isDropdownOpen ? "flex-div active" : "flex-div"} onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
              <img src={KidsIcon} alt="Crianças" />
              {(selectedOne.nickname !== undefined) ?
                <h4>{selectedOne.nickname}</h4> :
                <h4>{allChildren[0].nickname}</h4>
              }

              <FaAngleDown size={18} />
            </button>

          )}

          <Popover isFocused={isDropdownOpen}>
            {(isDropdownOpen && !loadingHeader) && (
              <div ref={buttonRef} className="scroll-children">
                {allChildren.map((child) => (
                  (child.nickname !== selectedOne.nickname) &&
                  <button
                    onClick={() => {
                      setSelectedOne(child)
                      setIsDropdownOpen(false)
                    }}
                    className="flex-div"
                    key={child._id}
                  >
                    <img src={KidsIcon} alt="Crianças" />
                    <h4>{child.nickname}</h4>
                  </button>
                ))}
              </div>
            )}
          </Popover>
        </>
      ) : (
        loadingHeader ? (
          <div className="loading">
            <Skeleton circle={true} height={48} width={48} />
            <Skeleton height={20} width={150} />
          </div>
        ) : (
          <div className="flex-div">
            <img src={KidsIcon} alt="Crianças" />
            {(selectedOne.nickname !== undefined) ?
              <h4>{selectedOne.nickname}</h4> :
              <h4>{allChildren[0].nickname}</h4>
            }
          </div>
        )
      )}
    </Header>
  );
}

export default ChildHeader;
